import React, { useState } from 'react'
import { Modal } from 'rsuite'
import Select from 'react-select'

import { toast } from '../../CommonComponents/ToastComponent/toast'

const SpendInfoModal = ({ show, onClose, spendTimeFrame, spendTimeType, onUpload }) => {
  const [timeType, setTimeType] = useState(spendTimeType || undefined)
  const [timeFrame, setTimeFrame] = useState(spendTimeFrame || undefined)

  const handleChangeSpendTimeFrame = (value) => {
    setTimeFrame(value)
  }
  const handleChangeSpendTimeType = (value) => {
    setTimeType(value)
  }

  const handleClickConfirm = () => {
    if (!timeType || timeType.value === '') {
      toast.show({
        title: 'Warning',
        description: 'Please select Spend Time Type.'
      })
      return
    }
    if (!timeFrame) {
      toast.show({
        title: 'Warning',
        description: 'Please input Spend Time Frame.'
      })
      return
    }
    onUpload(timeFrame, timeType)
  }

  const spendTimeTypeOptions = [
    {
      label: 'Years',
      value: 'years',
      rate: 1,
    },
    {
      label: 'Months',
      value: 'months',
      rate: 12,
    },
    {
      label: 'Days',
      value: 'days',
      rate: 365,
    },
  ]

  return (
    <Modal
      backdrop={true}
      className="spend-info-modal"
      show={show}
      size="xs"
      onClick={onClose}
      onHide={onClose}
    >
      <Modal.Header>
        <Modal.Title>
          Duration of Spend Imported
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="content">
          <div className="row flex">
            <h5>Spend Duration Type: </h5>
            <Select
              options={spendTimeTypeOptions}
              value={timeType}
              onChange={(val) => handleChangeSpendTimeType(val)}
              className="spend-time-type-select"
            />
          </div>
          <div className="row flex">
            <h5>Spend Time Period: </h5>
            <input type="number" defaultValue={timeFrame} onChange={e => handleChangeSpendTimeFrame(e.target.value)} />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="action-container">
          <button type="button" className="btn btn-gray" onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-black" onClick={handleClickConfirm}>
            Ok
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
export default SpendInfoModal